import React from 'react'

const MaximizeIcon = (props: any) => (
  <svg width={16} height={16} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path d='M10 2h4v4M6 14H2v-4M14 2 9.333 6.667M2 14l4.667-4.667' stroke='currentColor' strokeWidth={1.8} strokeLinecap='round' strokeLinejoin='round' />
  </svg>
)

export default MaximizeIcon